import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./styles.scss";
const FormLoader = props => {
  return (
    <div>
      {props.loading && (
        <div className={`form-loader ${props.absolute ? "absolute" : ""}`}>
          <div>
            <Loader type="TailSpin" color="#1F7A56" height={80} width={80} />
            <h3>{props.message}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormLoader;
